export default __webpack_public_path__ + "static/210521_妲絲刷關活動熱更預告_kr-faf9b3ee2af00a2e862cd5defb91abcc.webp";